import { get } from 'lodash';

const styles = ({ color, fontSize, fontWeight, margin, padding, typography }) => ({
  assistText: {
    marginLeft: 4,
  },
  textFiltersContainer: {
    display: 'flex',
    width: '100%',
    marginTop: '-30px !important',
    flexWrap: "wrap",
  },
  textFieldContainer: {
    margin: `${get(margin, 'm0')} !important`,
    marginLeft: `${get(margin, 'm8')} !important`,
    width: 200,
  },
  autoContainer: {
    padding: `${get(padding, 'p0')} ${get(padding, 'p6')} !important`,
    width: 250,
    marginTop: "1.3rem !important",
    marginLeft: `${get(margin, 'm5')} !important`,
  },
  fieldContainer: {
    margin: `${get(margin, 'm2')} ${get(margin, 'm4')} ${get(margin, 'm2')} ${get(margin, 'm0')} !important`,
    padding: '10px 0',
  },
  selectField: {
    padding: `${get(padding, 'p2')} ${get(padding, 'p10')} !important`,
  },
  assistTextIcon: {
    display: 'flex',
  },
  helpIcon: {
    color: color.primaryButtonBackground,
    marginLeft: 6,
    marginTop: 3,
    height: 16,
    width: 16,
  },
  assistTextContainer: {
    alignItems: 'center',
    display: 'flex',
  },
  helpIconContainer: {
    display: 'flex',
  },
  nameFieldContainer: {
    marginBottom: '0 !important',
    marginTop: '0px !important',
    width: '50%',
  },
  pageClass: {
    margin: '0 0',
  },
  pageFilterAndSortClass: {
    alignItems: 'end',
    marginBottom: 20,
    marginLeft: 36,
    marginRight: 36,
    marginTop: 0,
    padding: 0,
    width: 'auto',
  },
  pageTitle: {
    color: get(color, 'pageTitle'),
    fontFamily: get(typography, 'pageTitle'),
    fontSize: get(fontSize, 'pageTitle'),
    marginTop: 6,
  },
  itemState: {
    overflow: 'hidden',
    paddingTop: '5px',
    paddingBottom: '5px',
    paddingLeft: '10px',
    paddingRight: '10px',
    color: color.white,
    borderRadius: '20px',
  },
  complianceStatus: {
    alignItems: 'baseline',
    display: 'flex',
    '& > *': {
      marginRight: 4,
    },
  },
  checkCompliance: {
    color: get(color, 'success'),
    marginLeft: 18,
    verticalAlign: 'bottom',
  },
  cancelIconForCompliance: {
    color: get(color, 'error'),
    fontWeight: get(fontWeight, 'bold'),
    marginLeft: 18,
    verticalAlign: 'bottom',
  },
  greyIconForCompliance: {
    fill: get(color, 'gray'),
    fontWeight: get(fontWeight, 'medium'),
    marginLeft: 18,
    verticalAlign: 'bottom',
  },
  checkAssigned: {
    fill: get(color, '#114599'),
  },
  statusIcon: {
    height: 18,
    marginRight: 4,
    verticalAlign: 'middle',
    width: 18,
  },
  tickMark: {
    color: color.primaryButtonBackground,
    fontWeight: 'bold',
  },
});
  
export default styles;
